// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-UL1RU","text":"text-Swr_5","icon":"icon-Sfs-6"};